class ArnNewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.delay = parseInt(this.dataset.delay) * 1000 || 2000;
    this.modalId = this.dataset.modalId;
    this.acceptsMarketing = this.dataset.acceptsMarketing === 'true';
    this.modal = document.getElementById(this.modalId);
    this.closeBtn = this.modal?.querySelector('.newsletter-modal-close');
    this.modalContent = this.modal?.querySelector('.newsletter-modal-content');

    if (!this.modal) return;

    this.init();
  }

  init() {
    // Check sessionStorage for visibility state
    // If 'arn-newsletter-popup-closed' is 'true' or user is subscribed, do not show popup
    const popupClosed = sessionStorage.getItem('arn-newsletter-popup-closed') === 'true';
    const newsletterSubscribed = sessionStorage.getItem('arn-newsletter-subscribed') === 'true';

    if (this.acceptsMarketing || newsletterSubscribed || popupClosed) {
      return;
    }

    this.setupEventListeners();

    // Auto-open after delay
    setTimeout(() => this.openModal(), this.delay);
  }

  setupEventListeners() {
    // Close button handler
    this.closeBtn?.addEventListener('click', () => this.closeModal());

    // Close on backdrop click
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.closeModal();
      }
    });

    // Prevent modal content clicks from propagating to backdrop
    this.modalContent?.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('show')) {
        this.closeModal();
      }
    });
  }

  openModal() {
    document.body.classList.add('tw-overflow-hidden');
    this.modal.classList.add('show');
    this.modal.style.display = 'flex';
    this.modal.style.opacity = '1';
  }

  closeModal() {
    document.body.classList.remove('tw-overflow-hidden');
    this.modal.style.opacity = '0';

    setTimeout(() => {
      this.modal.classList.remove('show');
      this.modal.style.display = 'none';
    }, 300);

    // Remember close state in sessionStorage if enabled
    sessionStorage.setItem('arn-newsletter-popup-closed', 'true');
  }

  disconnectedCallback() {
    // Cleanup event listeners if needed
    this.closeBtn?.removeEventListener('click', () => this.closeModal());
    this.modal?.removeEventListener('click', () => this.closeModal());
    this.modalContent?.removeEventListener('click', (e) => e.stopPropagation());
  }
}

// Register the custom element
if (!customElements.get('arn-newsletter-popup')) {
  customElements.define('arn-newsletter-popup', ArnNewsletterPopup);
}